import { Grid, List, Skeleton } from '@mui/material';

export const PanelLoader = ({ maxItems = 8 }: { maxItems?: number }) => (
    <List sx={{ width: '100%', pl: '0.875rem', pr: '0.5rem' }}>
        {[...Array(maxItems)].map((el, index) => (
            <Grid component="li" key={index} container alignItems="center" justifyContent="space-between">
                <Grid item xs={4}>
                    <Skeleton height="1rem" animation="wave" />
                </Grid>
                <Grid item xs={7}>
                    <Skeleton height="2rem" animation="wave" />
                </Grid>
            </Grid>
        ))}
    </List>
);
